import React from 'react';
import './index.css';
import '../../karma.css';
import MarkdownRenderer from '../../../../markdown';

/**
 * Interface representing the props for the QuestionBody component.
 *
 * - views - The number of views the question has received.
 * - text - The content of the question, which may contain hyperlinks.
 * - askby - The username of the user who asked the question.
 * - meta - Additional metadata related to the question, such as the date and time it was asked.
 */
interface QuestionBodyProps {
  views: number;
  text: string;
  image?: string;
  askby: string;
  karma: number;
  meta: string;
}

/**
 * QuestionBody component that displays the body of a question.
 * It includes the number of views, the question content (with hyperlink handling),
 * the username of the author, and additional metadata.
 *
 * @param views The number of views the question has received.
 * @param text The content of the question.
 * @param askby The username of the question's author.
 * @param meta Additional metadata related to the question.
 */
const QuestionBody = ({ views, text, image, askby, karma, meta }: QuestionBodyProps) => {
  let karmaClass = 'karma-grey';
  if (karma && karma < 0) {
    karmaClass = 'karma-red';
  } else if (karma && karma > 0) {
    karmaClass = 'karma-green';
  }

  return (
    <div id='questionBody' className='questionBody right_padding'>
      <div className='bold_title answer_question_view'>{views} views</div>
      <div className='markdown-container'>
        <MarkdownRenderer text={text} />
      </div>
      <div className='answer_question_right'>
        <div className='question_author'>{askby}</div>
        <div className={karmaClass}>{karma} karma</div>
        <div className='answer_question_meta'>asked {meta}</div>
        {image && (
          <img
            src={image}
            alt='question'
            className='question_image'
            style={{ width: '300px', height: '300px' }}
          />
        )}
      </div>
    </div>
  );
};

export default QuestionBody;
